module.exports = __webpack_public_path__ + "img/image1.5af2195e.jpg";